import React from 'react'
import LoadingSpinner from '../loader/LoadingSpinner'

const Wrapper = ({ loading, children }) => {
    return (
        loading ? <div className='h-[100vh] w-[100vw] flex justify-center items-center'><LoadingSpinner /></div> : children
    )
}

export default Wrapper